import { isErrorRejected } from '../utils/ajax/apiErrorHandler'
import * as queryString from 'query-string'

import HttpStatus from 'common/utils/httpStatus'
import { axios, getNaverLoginURL, isBrowser } from 'common/utils'
import hostConfig from 'common/config'
import { isMobileEnv, isPcEnv } from 'common/utils/common'
import WindowMessages from 'common/constants/windowMessages'
import { isEmptyObject } from 'common/utils/logic/object'
import { ErrorTarget } from 'common/constants/error'
import { getRealNameAuthURL } from 'common/utils/naverLogin'
import { isIe9 } from 'common/utils/oldIeVersion'

enum WindowSize {
  WIDTH = 520,
  HEIGHT = 322,
}
const POPUP_BLOCKING_MESSAGE = '팝업창이 차단되어 있습니다.\n팝업창 설정을 변경해 주세요.'
export const isLogin = () => isBrowser && document.cookie.includes('NID_SES')
export const payOrder = () => {}
export const isValidLoginUser = (action?: WindowMessages, params?: Object) => {
  if (!isLogin()) {
    if (confirm('로그인이 필요한 서비스입니다. 로그인 하시겠습니까?')) {
      if (isMobileEnv) {
        window.location.href = getNaverLoginURL()
      } else {
        const url = `${window.location.protocol}//${window.location.hostname}/redirect/login`
        let mergedParams = {}
        if (action) {
          mergedParams = { ...mergedParams, action }
        }

        if (params && !isEmptyObject(params)) {
          mergedParams = { ...mergedParams, ...params }
        }
        const queryParams = isEmptyObject(mergedParams) ? '' : `?${queryString.stringify(mergedParams)}`
        window.open(
          `${url}${queryParams}`,
          '_blank',
          `width=${WindowSize.WIDTH},height=${WindowSize.HEIGHT},location=no,resizable=0`,
        )
      }
    }
    return false
  }
  return true
}

export const isValidPayUserWithThrowError = async () => {
  return await isValidPayUser(null, null, true)
}

export const isValidPayUser = async (action?: WindowMessages, params?: any, throwError?: boolean) => {
  let popupWindow: Window
  if (!isValidLoginUser(action, params)) {
    return false
  }
  try {
    if (isPcEnv) {
      if (params && params.popupLocation) {
        popupWindow = window.open(
          '',
          `${isIe9() ? '' : 'default'}`,
          `width=${WindowSize.WIDTH},height=${WindowSize.HEIGHT},resizable=0`,
        )
      }
    }
    await new Promise(resolve =>
      resolve(
        axios.get('/v1/members/checkPayUser', {
          data: {
            [isErrorRejected]: true,
          },
        }),
      ),
    )
  } catch (error) {
    // 상위에서 에러 처리하기 위함.
    if (throwError) {
      throw error
    }

    const errorResponse = error.response
    if (!(errorResponse && errorResponse.data && errorResponse.data.detailMessage)) {
      alert('잠시 후 다시 시도해주세요.')
      return false
    }

    if (errorResponse.status === HttpStatus.FORBIDDEN) {
      if (errorResponse.data.target === ErrorTarget.NAVER_REAL_NAME) {
        if (confirm(errorResponse.data.detailMessage)) {
          window.location.href = getRealNameAuthURL()
        }
        return false
      }

      if (errorResponse.data.target === ErrorTarget.NAVER_NOT_OVER_14_YEARS) {
        alert(errorResponse.data.detailMessage)
        return false
      }

      if (isMobileEnv) {
        alert(errorResponse.data.detailMessage)
        return
      }
      if (!popupWindow && params && params.popupLocation) {
        alert(POPUP_BLOCKING_MESSAGE)
        return
      }
      if (popupWindow) {
        popupWindow.location.href = `${hostConfig.naverPayUri.pc}/memberStopPopup`
      } else {
        const popupWindow = window.open(
          `${hostConfig.naverPayUri.pc}/memberStopPopup`,
          `${isIe9() ? '' : 'member-stop'}`,
          `width=${WindowSize.WIDTH},height=${WindowSize.HEIGHT},resizable=0`,
        )
        !popupWindow && alert(POPUP_BLOCKING_MESSAGE)
      }
      return false
    }

    if (errorResponse.status === HttpStatus.UNAUTHORIZED && errorResponse.data.target === ErrorTarget.PAY) {
      if (isMobileEnv) {
        if (errorResponse && errorResponse.data && errorResponse.data.detailMessage) {
          alert(errorResponse.data.detailMessage)
        }
        window.location.href = `${hostConfig.naverPayUri.mobile}/mobile/join?url=${encodeURIComponent(
          window.location.href,
        )}`
      } else {
        if (!popupWindow && params && params.popupLocation) {
          alert(POPUP_BLOCKING_MESSAGE)
          return
        }
        if (popupWindow) {
          popupWindow.location.href = `${hostConfig.naverPayUri.pc}/joinPopup`
        } else {
          const popupWindow = window.open(
            `${hostConfig.naverPayUri.pc}/joinPopup`,
            `${isIe9() ? '' : 'member-join'}`,
            `width=${WindowSize.WIDTH},height=${WindowSize.HEIGHT},resizable=0`,
          )
          !popupWindow && alert(POPUP_BLOCKING_MESSAGE)
        }
      }
      return false
    }

    alert(errorResponse.data.detailMessage)
    return false
  }
  if (params && params.popupLocation) {
    popupWindow.location.href = params.popupLocation
  }
  return true
}

export const getStoreUrlFromPayInformation = (
  merchantChannelServiceType: string,
  merchantUrl: string,
  merchantChannelUrl: string,
) => {
  return merchantChannelServiceType === null ? merchantUrl : merchantChannelUrl
}

export const getStoreNameFromPayInformation = (
  merchantChannelServiceType: string,
  merchantName: string,
  merchantChannelName: string,
) => {
  return merchantChannelServiceType === null ? merchantName : merchantChannelName
}

export const getChannelTypeFromPayInformation = (merchantChannelServiceType: string, merchantServiceType: string) => {
  switch (merchantChannelServiceType) {
    case 'STOREFARM':
    case '스마트스토어':
      return '스마트스토어'
    case 'SHOPPINGWINDOW':
    case '쇼핑윈도':
      return '쇼핑윈도'
    default:
      if (merchantServiceType === 'MP') {
        return '스마트스토어'
      }
      return '네이버페이'
  }
}
